import { render, staticRenderFns } from "./DotacaoForm.vue?vue&type=template&id=33e53788"
import script from "./DotacaoForm.vue?vue&type=script&lang=js"
export * from "./DotacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports